import { db } from "../firebase";
import { updateDoc, doc } from "firebase/firestore";

function getInfo(item) {
  if (item._role === "courier") {
    if (item.deliveryStatus === "accepted") return "Accepted — go pick up";
    if (item.deliveryStatus === "in_transit") return "In transit — deliver to receiver";
    return item.deliveryStatus || "Accepted";
  }
  if (item.claimType === "pickup") return item.completed ? "Completed" : "Go pick it up";
  if (item.claimType === "delivery") {
    if (item.deliveryStatus === "pending_delivery") return "Waiting for courier";
    if (item.deliveryStatus === "accepted") return "Courier on the way";
    if (item.deliveryStatus === "in_transit") return "On the way to you";
    if (item.deliveryStatus === "delivered") return "Delivered!";
  }
  return "Active";
}

export default function ActiveDeliveryPopup({ claims, isOpen, onToggle, onCancelClaim, onSendKudos, onMarkReceived, onMarkDone }) {
  const visible = claims || [];

  const content = (
    <>
      {visible.length === 0 && (
        <p className="text-sm text-gray-400 text-center py-8">No active claims yet. Claim food from the map or receiver tab!</p>
      )}
      {visible.map(item => (
        <div key={item.id} className="relative p-3 bg-gray-50/80 rounded-xl border border-gray-200/60 mb-3">
          <button onClick={() => { if (window.confirm("Cancel this claim?")) onCancelClaim(item.id, item._role); }} className="absolute top-2 right-2 w-6 h-6 rounded-full bg-gray-200/80 hover:bg-red-100 text-gray-500 hover:text-red-600 flex items-center justify-center text-xs" title="Cancel claim">✕</button>
          <h3 className="font-bold text-gray-800 pr-8">{item.name}</h3>
          <p className="text-xs text-gray-500 mt-0.5">{getInfo(item)}</p>
          <div className="flex gap-1 mt-2">
            {item.claimType === "delivery" && <span className="text-[10px] bg-blue-100 text-blue-600 px-1.5 py-0.5 rounded-full">Delivery</span>}
            {item.claimType === "pickup" && <span className="text-[10px] bg-green-100 text-green-600 px-1.5 py-0.5 rounded-full">Pickup</span>}
            {item._role === "courier" && <span className="text-[10px] bg-amber-100 text-amber-600 px-1.5 py-0.5 rounded-full">Courier</span>}
          </div>
          {item.address && <p className="text-xs text-gray-400 mt-1 truncate">Pickup: {item.address}</p>}
          {item.deliveryAddress && <p className="text-xs text-gray-400 truncate">Drop-off: {item.deliveryAddress}</p>}
          <p className="text-xs text-gray-400 mt-0.5">Qty: {item.quantity}</p>

          {item.claimType === "pickup" && item._role === "receiver" && !item.completed && (
            <button onClick={async () => { await updateDoc(doc(db, "food_posts", item.id), { completed: true }); onMarkDone?.({ ...item, completed: true }); }} className="btn-pop mt-2 w-full py-2 bg-green-500 text-white text-xs font-semibold rounded-lg hover:bg-green-600">✓ Mark Picked Up</button>
          )}
          {item._role === "courier" && item.deliveryStatus === "accepted" && (
            <button onClick={async () => { await updateDoc(doc(db, "food_posts", item.id), { deliveryStatus: "in_transit" }); }} className="btn-pop mt-2 w-full py-2 bg-amber-500 text-white text-xs font-semibold rounded-lg hover:bg-amber-600">Picked Up — In Transit</button>
          )}
          {item._role === "courier" && item.deliveryStatus === "in_transit" && (
            <button onClick={async () => { await updateDoc(doc(db, "food_posts", item.id), { deliveryStatus: "delivered" }); }} className="btn-pop mt-2 w-full py-2 bg-green-500 text-white text-xs font-semibold rounded-lg hover:bg-green-600">Mark Delivered</button>
          )}
          {item._role === "receiver" && item.claimType === "delivery" && item.deliveryStatus === "delivered" && !item.receiverConfirmed && onMarkReceived && (
            <button onClick={async () => { await onMarkReceived(item); }} className="btn-pop mt-2 w-full py-2 bg-green-500 text-white text-xs font-semibold rounded-lg hover:bg-green-600">✓ Mark as Received</button>
          )}
          {item._role === "receiver" && onSendKudos && ((item.claimType === "pickup" && item.completed && !item.kudosSent) || (item.claimType === "delivery" && ["accepted", "in_transit", "delivered"].includes(item.deliveryStatus) && (!item.kudosSent || (item.courierId && !item.courierKudosSent)))) && (
            <button onClick={() => onSendKudos(item)} className="btn-pop mt-2 w-full py-2 bg-amber-50 text-amber-700 text-xs font-semibold rounded-lg border border-amber-200 hover:bg-amber-100 flex items-center justify-center gap-1">🙏 Send Kudos</button>
          )}
        </div>
      ))}
    </>
  );

  return (
    <>
      <div className={`glass-hover hidden md:block fixed top-[91px] left-4 z-[1000] w-96 max-h-[calc(100vh-6.5rem)] bg-white/85 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/40 transition-all duration-300 ${isOpen ? "translate-x-0 opacity-100" : "-translate-x-[110%] opacity-0"}`}>
        <div className="flex items-center justify-between px-5 py-3 border-b border-gray-200/50">
          <h2 className="text-lg font-semibold text-gray-800">My Claims</h2>
          {visible.length > 0 && <span className="text-xs bg-green-100 text-green-600 px-2 py-0.5 rounded-full font-medium">{visible.length}</span>}
          <button onClick={onToggle} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 text-gray-500">✕</button>
        </div>
        <div className="overflow-y-auto max-h-[calc(100vh-10.5rem)] p-4">{content}</div>
      </div>
      <div className={`glass-hover md:hidden fixed left-0 right-0 bottom-0 z-[1002] bg-white/90 backdrop-blur-xl rounded-t-3xl shadow-2xl border-t transition-all duration-300 ${isOpen ? "translate-y-0" : "translate-y-full"}`} style={{ maxHeight: "70vh" }}>
        <div className="flex justify-center pt-3 pb-1"><div className="w-10 h-1 bg-gray-300 rounded-full"></div></div>
        <div className="flex items-center justify-between px-5 py-3 border-b">
          <h2 className="text-lg font-semibold">My Claims</h2>
          <button onClick={onToggle} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100">✕</button>
        </div>
        <div className="overflow-y-auto p-4" style={{ maxHeight: "calc(70vh - 5rem)" }}>{content}</div>
      </div>
    </>
  );
}
